module.exports = __webpack_public_path__ + "img/articleDevenirParent3.1282e554.png";